const NoInternetAction = () => {
  const checkConnection = window.navigator.onLine ? 'on' : 'off';
  if (checkConnection === 'off') {
    return {
      type: 'OFFLINE',
    };
  } else {
    return {
      type: 'ONLINE',
    };
  }
};

export default NoInternetAction;
